import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { OutboundEmailRow } from '../../models/outbound-emails.model';
import { getAttachmentCount } from '../../utils/attachment-count';

type OnClickFn = (data: OutboundEmailRow) => void;

export interface ViewAttachmentsCellRendererParams extends ICellRendererParams<OutboundEmailRow> {
  onClick?: OnClickFn;
}

@Component({
  selector: 'app-view-attachments-cell-template',
  templateUrl: './view-attachments-cell-template.component.html',
  styleUrl: './view-attachments-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewAttachmentsCellTemplateComponent implements ICellRendererAngularComp {
  params: ViewAttachmentsCellRendererParams;

  private onClickFn: OnClickFn | undefined;

  data = signal<OutboundEmailRow>(undefined);
  attachmentCount = computed(() => getAttachmentCount(this.data()));
  label = computed(() => `View ${this.attachmentCount()} ${this.attachmentCount() === 1 ? 'Attachment' : 'Attachments'}`);

  agInit(params: ViewAttachmentsCellRendererParams): void {
    this.params = params;
    this.data.set(params.data);
    this.onClickFn = params.onClick;
  }

  onClick(): void {
    this.onClickFn?.(this.data());
  }

  refresh(): boolean {
    return false;
  }
}
